import { EllipsedText, Loading, MaterialIcon, VirtualizedComponent } from '@gorila-shared-ui/components';
import { ListItem, ListItemLabel } from 'baseui/list';
import { CSSProperties, memo, useRef } from 'react';
import { ListChildComponentProps } from 'react-window';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHover } from 'usehooks-ts';
import { SMALL_LIST_ITEM_HEIGHT } from '../../constants/app';
import { useStyles } from '../../hooks/useStyles';
import { placeState, selectedPlaceIdState } from '../../storage/places';

function PlaceItem({ data, index, style }: Readonly<ListChildComponentProps<VirtualizedComponent['data']>>) {
  const { classes, concatenateClasses, css, theme, overrides } = useStyles();
  const [selectedPlaceId, setSelectedPlaceId] = useRecoilState(selectedPlaceIdState);
  const placeId = data.items[index];
  const place = useRecoilValue(placeState(placeId));
  const hoverRef = useRef(null);
  const isHover = useHover(hoverRef);

  const isSelected = selectedPlaceId === placeId;

  const onSelectPlace = () => {
    if (selectedPlaceId === placeId) setSelectedPlaceId(undefined);
    else setSelectedPlaceId(placeId);
  };

  return (
    <span
      style={style as CSSProperties}
      ref={hoverRef}
    >
      {data.isLoaded(index) ? (
        <ListItem
          overrides={overrides.listItemOverrides({
            onClick: onSelectPlace,
            isHover,
            isSelected,
            minHeight: SMALL_LIST_ITEM_HEIGHT,
          })}
        >
          <ListItemLabel>
            <span
              className={concatenateClasses(
                classes.horizontalFlex,
                classes.centeredStart,
                css({ gap: theme.sizing.scale500 }),
              )}
            >
              <span className={css({ flexShrink: 0, lineHeight: 0 })}>
                <MaterialIcon name="home_pin" />
              </span>
              <EllipsedText
                inline
                breakAll
              >
                {place?.address || '-'}
              </EllipsedText>
            </span>
          </ListItemLabel>
        </ListItem>
      ) : (
        <Loading size="compact" />
      )}
    </span>
  );
}

export default memo(PlaceItem);
